import { render } from "./PatientPreadmissionNotesForm.vue?vue&type=template&id=5fdb96f1&ts=true"
import script from "./PatientPreadmissionNotesForm.ts?vue&type=script&lang=ts&external"
export * from "./PatientPreadmissionNotesForm.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__